import {
  getFunctions,
  httpsCallable,
} from "firebase/functions";

import app from "../firebase";

const functions = getFunctions(
  app,
  "asia-south1"
);

const extractGuestIdWithAI =
  httpsCallable(
    functions,
    "extractGuestIdWithAI"
  );

const MAX_DIMENSION = 1800;
const JPEG_QUALITY = 0.84;

const isFile = (value) =>
  typeof File !== "undefined" &&
  value instanceof File;

const loadImage = (file) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };

    image.onerror = (error) => {
      URL.revokeObjectURL(url);
      reject(error);
    };

    image.src = url;
  });

const fileToCompressedDataUrl = async (
  file
) => {
  if (!isFile(file)) {
    return "";
  }

  const image = await loadImage(file);

  const scale = Math.min(
    1,
    MAX_DIMENSION /
      Math.max(
        image.naturalWidth,
        image.naturalHeight
      )
  );

  const width = Math.max(
    1,
    Math.round(
      image.naturalWidth * scale
    )
  );

  const height = Math.max(
    1,
    Math.round(
      image.naturalHeight * scale
    )
  );

  const canvas =
    document.createElement("canvas");

  canvas.width = width;
  canvas.height = height;

  const context =
    canvas.getContext("2d", {
      alpha: false,
    });

  context.fillStyle = "#ffffff";
  context.fillRect(
    0,
    0,
    width,
    height
  );

  context.drawImage(
    image,
    0,
    0,
    width,
    height
  );

  return canvas.toDataURL(
    "image/jpeg",
    JPEG_QUALITY
  );
};

const prepareImage = async ({
  file,
  url,
}) => {
  if (isFile(file)) {
    return fileToCompressedDataUrl(
      file
    );
  }

  if (
    typeof url === "string" &&
    url.trim()
  ) {
    return url.trim();
  }

  return "";
};

export const analyzeGuestId = async ({
  frontFile,
  backFile,
  frontUrl,
  backUrl,
}) => {
  const [frontImage, backImage] =
    await Promise.all([
      prepareImage({
        file: frontFile,
        url: frontUrl,
      }),
      prepareImage({
        file: backFile,
        url: backUrl,
      }),
    ]);

  if (!frontImage && !backImage) {
    throw new Error(
      "Pehle ID Front ya Back image select karo."
    );
  }

  const response =
    await extractGuestIdWithAI({
      frontImage,
      backImage,
    });

  return response?.data || {};
};

export default analyzeGuestId;
